// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentComment_container_LjOLz","comment":"PaymentComment_comment_2H3JL","loading":"PaymentComment_loading_c8f5t","loadingActive":"PaymentComment_loadingActive_sLTBI"};